/* ©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
Bangalore, India. All Rights Reserved. */
/* 
This is recent transactions page having transactions from operative and credit card accounts */
/* <script type="text/javascript" src="http://maps.googleapis.com/maps/api/js?sensor=false"></script> */
import {
	html,
	Polymer
} from '@polymer/polymer/polymer-legacy.js';
import '@polymer/paper-item/paper-item.js';
import '@polymer/iron-dropdown/iron-dropdown.js';
import '@polymer/paper-listbox/paper-listbox.js';
import '@polymer/iron-collapse/iron-collapse.js';
import './app-network-error.js';


const template = html`
		<style include="app-styles">
			.min-height {
				min-height: 100px;
			}
			
      
	  .item {
		display: flex;
		justify-content: space-between;
		padding-bottom: 10px;
		margin-bottom: 10px;
		border-bottom: 1px solid #ccc;
	  }
	 

	paper-dropdown-menu {
		width: 140px;
		margin-top: -7px;
		--paper-dropdown-menu-icon_-_color: var(--brand-color);
		--paper-item_-_font-size: var(--a-font-size-s);
		--paper-input-container-underline: {
			display: none;
		}
		--paper-input-container-underline-focus: {
			display: none;
		}
		--paper-input-container-input: {
			text-align: right;
			color: var(--brand-color);
			font-size: 14px;
		}
	}

	#recentTransDialog {
		background-color: red;
	}
	app-dialog {
		--dialog-background-color: {
			background-color: var(--brand-color);
		}
		--dialog-text-color: {
			color: var(--background-primary);
		}
		--outline-offset-close: {
		  outline:2px solid rgba(0,0,0,0.87);
		}
	}
	.item.modal {
		font-size: var(--a-font-size-s);
		border: none;
	}	
	.item.modal > div {
		display: flex;
		flex-direction: column;
		padding: 15px;
		width: 140px;
		text-align: left;
	}
	.item.modal > div > div:first-child {
		font-weight: 600;
	}

	.dashboard-paper-card-recent {
		height: 268px;
		overflow-y: auto;
		overflow-x:hidden;
	}

	.iron-collapse-icon {
		transition: transform .2s;
		-webkit-transition: -webkit-transform .2s;
		-moz-transition: -moz-transform .2s;
		-ms-transition: -ms-transform .2s;
		-o-transition: -o-transform .2s;
		
		transform: rotate(-90deg);
		-webkit-transform: rotate(-90deg);
		-moz-transform: rotate(-90deg);
		-o-transform: rotate(-90deg);
	}

	.iron-collapse-open {
		transform: rotate(90deg);
		-webkit-transform: rotate(90deg);
		-moz-transform: rotate(90deg);
		-o-transform: rotate(90deg);
	}
	.font-size1{
		font-size:initial;
	}
	
	::-webkit-scrollbar-thumb {
		background: var(--elevation-color);
		border-radius: 10px;
		border: 6px solid transparent;
		background-clip: content-box;
	}
	::-webkit-scrollbar-track {
		border: 8px solid transparent !important;
		background: transparent !important;
		background-clip: content-box;
	}

	.supporting-message-wrapper, .loader-wrapper {
		height: calc(100% - 22px);
	}

	.iron-drop-down {
		background: var(--card-light-background);
	}

	.recent-transaction-wrapper ::-webkit-scrollbar {
		width: 0;
	}
        </style>
        
        <app-media-query phone={{phone}} desktop={{desktop}} tablet={{tablet}}></app-media-query>
		<div>
			<div class$="outlineOffset recent-transaction-wrapper mdl-grid {{_getWrapperClassName(phone)}}" on-tap="_toggleIronCollapse" tabindex="0">
				<div class="mdl-cell mdl-cell--6-col mdl-cell--2-col-phone primary-dark-text-m font-medium outlineOffset" role="heading" aria-level="2" tabindex="0">
					<oe-i18n-msg msgid="h_RecentTransactions"></oe-i18n-msg>
				</div>
				<div class="mdl-cell mdl-cell--6-col mdl-cell--2-col-phone content-align-horizontal-end margin-b-zero margin-t-zero content-align-center" hidden$="{{noAccountsList}}">
					<div hidden$="{{!ironCollapseState}}" on-tap="_stopEventPropagation">
						<paper-button class="outlineOffset text-brand-color font-size-s padding-t-zero padding-b-zero" on-tap="_toggleIronDropdown">
							<span>
								{{accountFormat(selectedAccount)}}
							</span>
							<iron-icon icon="arrow-drop-down">
							</iron-icon>
						</paper-button>
						<iron-dropdown class="random-content" horizontal-align="left" vertical-align="top"  id="ironDropdown" no-overlap scroll-action="cancel">
							<div id="ironItem" class="iron-drop-down elevation-2" slot="dropdown-content">
								<template is="dom-repeat" items="{{oprAccountList}}" as="account">
									<div>
										<paper-button class="margin-zero full-width display-block font-size-s" data-item$="[[accountFormat(account)]]" index$="{{index}}" on-tap="_itemSelected">
											{{accountFormat(account)}}
										</paper-button>
									</div>
								</template>
							</div>
						</iron-dropdown>
					</div>
					<iron-icon id="ironCollapseIcon" icon="chevron-left" class="iron-collapse-icon" hidden$="{{!phone}}">
					</iron-icon>
				</div>				
			</div>
			<iron-collapse id="relevantTransactions" opened="{{ironCollapseState}}">
				<div class="dashboard-paper-card-recent">

					<template is="dom-if" if="{{!showRecentTransactionMsg && !showNodataFetchMsg}}">
						<div class="full-width" hidden$="{{recentTransactionLoader}}">
							<div class="mdl-grid">
								<template is="dom-repeat" items="{{transactions}}" index-as="{{index}}">
									<div class="outlineOffset cursor-pointer mdl-cell mdl-cell--12-col mdl-grid padding-lr-zero margin-t-zero" Indexvalue={{index}} on-tap="selectTransaction" id="selTrans" tabindex="0">
										<div class="half-width">
											<div class="primary-dark-text-m text-overflow-ellipsis font-medium full-width">{{item.displayName}}</div>
											<div class="horizontal layout center text-overflow-ellipsis secondary-dark-text-xs">{{item.displayMonthDate.primaryDate}} {{item.displayMonthDate.monthName}}, {{item.displayDate}}</div>
										</div>
										<div class="half-width display-flex content-align-horizontal-end">
											<template is="dom-if" if="{{item.displayValueSign}}" restamp=true>
												<!--span class="minus-sign font-size1">&#8722;</span-->
                        <currency-formator class="primary-dark-text-m text-overflow-ellipsis" format-value={{item.displayValueSign}}{{item.displayValue}}></currency-formator>
											</template>
                      <template is="dom-if" if="{{!item.displayValueSign}}" restamp=true>
											<currency-formator class="primary-dark-text-m text-overflow-ellipsis" format-value="{{item.displayValue}}"></currency-formator>
                      </template>
                      </div>
									</div>
									<div class="border-b-1px full-width mdl-cell margin-t-zero" hidden$="{{_hideLastBorder(index)}}"></div>
								</template>
							</div>
						</div>	
					</template>
					<template is="dom-if" if="{{showRecentTransactionMsg}}">
						<div class="min-height horizontal center-center layout supporting-message-wrapper">
							<supporting-msg  description="" icon-name="no_txn" background="light-background" title-msg="l_noRecentTransactionsFound"></supporting-msg>
						</div>
					</template>	
					<template is="dom-if" if="{{recentTransactionLoader}}">
						<div class="min-height horizontal center-center layout loader-wrapper">
							<paper-spinner id="recent_transaction_spinner" active class="spinner-mobile"></paper-spinner>
						</div>
					</template>	
					<!-- <template is="dom-if" if="{{showRecentTransactionMsg}}">
						<div class="min-height horizontal center-center layout supporting-message-wrapper">
							<supporting-msg  description="" icon-name="no_txn" background="light-background" title-msg="l_noRecentTransactionsFound"></supporting-msg>
						</div>
					</template>	-->
					<template is="dom-if" if="{{showNodataFetchMsg}}">
						<div class="min-height horizontal center-center layout supporting-message-wrapper">
							<app-network-error  icon-name="cloud-off" background="light-background" description="l_try_after_sometime" title="l_could_not_fetch_data"></app-network-error>
						</div>
					</template>	
				</div>
			</iron-collapse>
		</div>
		<app-dialog  name="l_recentTransactionDetail" aria-label$="{{getLabel('h_groupTag')}}"  id="recentTransDialog" elementid="recentTransDialog">
		<template is="dom-repeat" items={{selTransaction}}>
			<div class="item modal">
			<div class="item1">
				<div>{{item.transID}}</div>
				<div><oe-i18n-msg msgid="l_TransactionId"></oe-i18n-msg></div>
			</div>
			<div class="item2">
			<div>{{item.transDate.primaryDate}} {{item.transDate.monthName}} {{item.transDate.year}}, {{item.transDateTime}}</div>
				<div><oe-i18n-msg msgid="l_TransactionDate"></oe-i18n-msg></div>
			</div>
			<div class="item3">
			<div>{{item.valueDate.primaryDate}} {{item.valueDate.monthName}} {{item.valueDate.year}}, {{item.valueDateTime}}</div>
				<div><oe-i18n-msg msgid="l_ValueDate"></oe-i18n-msg></div>
			</div>
			</div>
			<div class="item modal">
			<div class="item1" hidden$="{{item.transID}}">
				<div></div>
				<div><oe-i18n-msg msgid="l_TransactionNature"></oe-i18n-msg></div>
			</div>
			<div class="item2" hidden$="{{item.transID}}">
				<div></div>
				<div><oe-i18n-msg msgid="l_TransactionCategory"></oe-i18n-msg></div>
			</div>
			<div class="item3" hidden$="{{item.transID}}">
				<div></div>
				<div><oe-i18n-msg msgid="l_InstrumentId"></oe-i18n-msg></div>
			</div>
			</div>
		</template>
            
        </app-dialog>`;

Polymer({
	is: 'dashboard-recent-transactions',
	_template: template,
	properties: {
		ironCollapseState: {
			type: Boolean,
			value: false,
			notify: true
		},
		allAccountList: {
			type: Array,
			notify: true
		},
		/* savings */
		savings: {
			type: Array,
			notify: true,
			observer: '_savingsCardsChanged'
		},
		/* cards */
		cards: {
			type: Array,
			notify: true,
			observer: '_savingsCardsChanged'
		},
		/* transactions */
		transactions: {
			type: Array,
			value: [],
			notify: true
		},
		/* numberOfTransactions */
		numberOfTransactions: {
			type: Number,
			notify: true
		},
		/* recentTransactionLoader */
		recentTransactionLoader: {
			type: Boolean,
			value: true,
			notify: true
		},
    recentTransactionLoaderFlag: {
      type: Boolean,
      notify: true,
      observer: '_flagChange'
    },
    showRecentTransactionMsgFlag: {
      type: Boolean,
      notify: true,
      observer: '_flagChange'
		},
		/* transactionsAvailable */
		transactionsAvailable: {
			type: Boolean,
			value: true,
			notify: true
		},
		/* showGoogleDrive */
		showGoogleDrive: {
			type: Boolean,
			value: false,
			notify: true
		},
		accountList: {
			type: Array,
			notify: true,
		},
		oprAccountList: {
			type: Array,
			notify: true,
			observer: "_savingsCardsChanged"
		},
		selectedAccount: {
			type: Object,
			notify: true,
			value: {}
		},
		Indexvalue: {
			type: Number,
			notify: true
		},
		selTransaction: {
			type: Array,
			value: []
		},
		objTrans: {
			type: Object,
			value: {}
		},
    oprAccList: {
      type: Array,
      notify: true,
      observer: "_flagChange"
    },
		showAccountSelector: {
			type: Boolean,
			value: false,
			notify: true
		},
		showRecentTransactionMsg: {
			type: Boolean,
			value: false,
			notify: true
    },
    tempobj: {
      type: Object,
      notify: true,
      observer: "_flagChange"
		},
		showNodataFetchMsg: {
			type: Boolean,
			value: false,
			notify: true
		},
		noAccountsList: {
			type: Boolean,
			value: true,
			notify: true
		},
		showHideAccList: {
			type: Boolean,
			value: true
		}
	},
	//This function formats the account id into the masked format
	accountFormat: function (loanaccount) {
		return maskAccount.accountFormat(loanaccount.accountId, loanaccount.branchCode);
	},

	_stopEventPropagation: function (e) {
		e.stopPropagation();
	},

	_getWrapperClassName: function (phone) {
		return phone ? 'padding-r-zero' : 'padding-r-zero padding-b-zero';
	},
	_toggleIronDropdown: function () {
		if (this.showHideAccList) {
			this.$.ironDropdown.open();
		} else {
			this.$.ironDropdown.close();
		}
		this.showHideAccList = !this.showHideAccList;
	},

	_hideLastBorder: function(index) {
		return (this.transactions.length - 1 === index);
	},
  _flagChange: function () {
    if (this.tempobj != undefined) {
      this.recentTransactionLoader = this.tempobj.recentTransactionLoaderFlag;
      this.showRecentTransactionMsg = this.tempobj.showRecentTransactionMsgFlag;
    }

    if (this.oprAccList) {
      this.oprAccountList = this.oprAccList;
      if (this.oprAccountList.length === 0) {
        this.noAccountsList = true;
        this.showRecentTransactionMsg = true;
      } else {
        this.noAccountsList = false;
        this.selectedAccount = this.oprAccountList[0];
      }

      //  tempAccList = null;
    }
  },
  _itemSelected: function (e) {
    this._toggleIronDropdown();

    if (e.model.account.accountId !== this.selectedAccount.accountId) {
      this.recentTransactionLoader = true;
      this.showNodataFetchMsg = false;
      this.showRecentTransactionMsg = false;
      var selectedItem = e.target.dataset.item.trim();
      var selectedIndex = e.target.getAttribute('index');
      this.selectedAccount = this.oprAccountList[selectedIndex];

      if (selectedItem) {
        if (this.savings != undefined && this.cards != undefined) {
          var self = this;
          var transData = [];
          var accntArry = [self.savings, self.cards];

          if (accntArry[0].length > 0 || accntArry[1].length > 0) {
            var ajaxCall = document.createElement('oe-ajax');
            ajaxCall.contentType = "application/json";
            ajaxCall.handleAs = "json";
            ajaxCall.url = "/api/" + "operativeaccounts" + "/" + this.oprAccountList[selectedIndex].accountId + "/transactions?filter[order]=transactionDate%20DESC&filter[limit]=" + self.numberOfTransactions;
            ajaxCall.method = 'get';
            ajaxCall.addEventListener('response', function (event) {
              if (event.detail.response.length > 0) {
                _.forEach(event.detail.response, function (value) {
                  transData.push(value);
                });
              }

              self._sortTransactions(transData);

              self.showRecentTransactionMsg = self.transactions.length === 0;
              self.recentTransactionLoader = false;
            });
            oeAjaxEventListner(ajaxCall);
            ajaxCall.addEventListener('error', function (event) {
              self.transactions = [];

              if (event.detail.error.message.indexOf('404') !== -1) {
                self.showRecentTransactionMsg = true;
              } else {
                self.showNodataFetchMsg = true;
              }

              self.recentTransactionLoader = false;
            });
            ajaxCall.generateRequest();
          } else {
            this.transactions = [];
            this.recentTransactionLoader = false;
          }
        }
      }
    }
  },

	/* @event _checkLastIndex
	 * event to check the length
	 */
	_checkLastIndex: function (index, transactions) {
		if (index === transactions.length - 1)
			return true;
		return false;
	},
	/**
	 * Use for one-time configuration of your component after local
	 * DOM is initialized.
	 */
	ready: function () {
		this.showRecentTransactionMsg = false;
		this.ironCollapseState = !this.phone;
		this.userid = clientStorage.get(storageType.session, 'userId');
    var ajaxCall = document.createElement('oe-ajax');
    ajaxCall.contentType = "application/json";
    ajaxCall.handleAs = "json"; // API to fetch accounts list to show in dropdown

    ajaxCall.url = '/api/CBUsers/' + clientStorage.get(storageType.session, 'userId') + '/operativeaccounts';
    ajaxCall.method = 'get';
    ajaxCall.addEventListener('response', function (event) {
      //Dirty checking array for dom-repeat
      var tempAccList = _.cloneDeep(event.detail.response);

      this.oprAccountList = [];
      this.oprAccountList = tempAccList;

      if (this.oprAccountList.length === 0) {
        this.noAccountsList = true;
        this.showRecentTransactionMsg = true;
      } else {
        this.noAccountsList = false;
        this.selectedAccount = this.oprAccountList[0];
      }

      tempAccList = null;
    }.bind(this));
    ajaxCall.addEventListener('error', function (event) {
      console.log(event.detail.error);
      this.showRecentTransactionMsg = true;
      this.recentTransactionLoader = false;
    }.bind(this));
    oeAjaxEventListner(ajaxCall);
    ajaxCall.generateRequest();
		if (isDevMode()) {
			this.showGoogleDrive = true;
		}
		this.numberOfTransactions = config.SpeedBoat.App.dashboard.numberOfTransaction;
		this.dateFormat = clientStorage.get(storageType.session, "dateFormat");
		this._sortTransactions = function (tranData) {
			//alert("_sortTransactions");
			tranData.sort(function (a, b) {
				return getNewDate(b.transactionDate).getTime() - getNewDate(a.transactionDate).getTime();
			});
			tranData.splice(this.numberOfTransactions);
			for (var i = 0; i < tranData.length; i++) {
				tranData[i] = this._addDisplayValue(tranData[i]);
				tranData[i].appFabName = tranData[i].transactionRemarks ? tranData[i].transactionRemarks : getLabel("l_transactionCompleted");
				tranData[i].displayName = tranData[i].transactionRemarks ? tranData[i].transactionRemarks : getLabel("l_transactionCompleted");
			}
			if (tranData.length <= 0)
				this.transactionsAvailable = false;
			this.transactions = tranData;
			for (i = 0; i < this.transactions.length; i++) {
				this.getLocationDetails(this.transactions[i].displayLat, this.transactions[i].displayLng, i);
			}

			this.recentTransactionLoader = false;
			this.showAccountSelector = true;
			//this.readDrive();
		}
	},
	/* @event readDrive */
	//Google Drive - @Start
	readDrive: function () {
		//drive code
		if (isDevMode()) {
			var self = this;
			var getFilesPromise = this._getDriveFiles("Receipt");
			getFilesPromise.then(function (files) {
				for (var i = 0; i < self.transactions.length; i++) {
					var filePresentInDrive = false;
					for (var j = 0; j < files.length; j++) {
						if ("Receipt_" + self.transactions[i].transactionDate + ".pdf" === files[j].name) {
							self.transactions[i].googleDrive = {
								'present': true,
								'url': files[j].webViewLink
							};
							filePresentInDrive = true;
							document.getElementById("drive-" + i).style.visibility = 'visible';
							break;
						}
					}
					if (!filePresentInDrive) {
						self.transactions[i].googleDrive = {
							'present': false
						};
					}
				}


			});
		}

	},
	/* @event viewDocument
	 * event to view document
	 */
	viewDocument: function (e) {
		var x = screen.width / 2 - 700 / 2;
		var y = screen.height / 2 - 450 / 2;
		var webViewLink = this.transactions[e.currentTarget.index].googleDrive.url;
		window.open(webViewLink, 'popUpWindow', 'height=485,width=700,left=' + x + ',top=' + y);
	},
	/* @event _getDriveFiles
	 * event to get drive files
	 */
	_getDriveFiles: function () {

		return new Promise(function (resolve, reject) {

			const oauthToken = clientStorage.get(storageType.session, 'driveToken');
			var modelGetAjax = document.createElement('oe-ajax');
			modelGetAjax.handleAs = "json";
			modelGetAjax.url = 'https://www.googleapis.com/drive/v3/files';
			modelGetAjax.method = "get";

			var headers = {
				'Authorization': 'Bearer ' + oauthToken
			};
			modelGetAjax.headers = headers;

			var params = {
				q: "name contains 'Receipt_'",
				fields: '*'
			};
			modelGetAjax.params = params;
			oeAjaxEventListner(modelGetAjax);
			modelGetAjax.generateRequest();
			modelGetAjax.addEventListener('response', function (event) {
				var files = event.detail.response.files;
				resolve(files);

			});

			modelGetAjax.addEventListener('error', function (error) {
				reject(error);
			});
		});

	},
	/* @event _addDisplayValue
	 * event to display values
	 */
	//Google Drive - @End
	_addDisplayValue: function (item) {
		if (item.transactionDate != undefined && item.transactionDate != undefined) {
			item.displayDate = this._formatTime(getNewDate(item.transactionDate));
			item.displayMonthDate = this._formatDateTime(getNewDate(item.transactionDate));
		}

		if (item.locationCoordinates != undefined && item.locationCoordinates.lat != undefined && item.locationCoordinates.lng != undefined) {
			item.displayLat = parseFloat(item.locationCoordinates.lat);
			item.displayLng = parseFloat(item.locationCoordinates.lng);
		}

		//Add displayName and app-fab details
		if (item.TransactionExtension != undefined) {
			if (item.TransactionExtension.payee != undefined) {
				if (item.TransactionExtension.payee.url != undefined)
					item.appFabImage = item.TransactionExtension.payee.url;
				else
					item.appFabName = item.TransactionExtension.payee.name;
				item.displayName = item.TransactionExtension.payee.name;
			} else if (item.TransactionExtension.payer != undefined) {
				if (item.TransactionExtension.payer.url != undefined)
					item.appFabImage = item.TransactionExtension.payer.url;
				else
					item.appFabName = item.TransactionExtension.payer.name;
				item.displayName = item.TransactionExtension.payer.name;
			} else if (item.TransactionExtension.biller != undefined) {
				if (item.TransactionExtension.biller.url != undefined)
					item.appFabImage = item.TransactionExtension.biller.url;
				else
					item.appFabName = item.TransactionExtension.biller.name;
				item.displayName = item.TransactionExtension.biller.name;
			}
			if (item.TransactionExtension.locationCoordinates != undefined && item.TransactionExtension.locationCoordinates.lat != undefined && item.TransactionExtension.locationCoordinates.lng != undefined) {
				item.displayLat = parseFloat(item.TransactionExtension.locationCoordinates.lat);
				item.displayLng = parseFloat(item.TransactionExtension.locationCoordinates.lng);
			}
		} else if (item.merchant != undefined) {
			if (item.merchant.imageUrl != undefined)
				item.appFabImage = item.merchant.imageUrl;
			else
				item.appFabName = item.merchant.name;
			item.displayName = item.merchant.name;
		} else {
			item.appFabName = item.transactionRemarks;
			item.displayName = item.transactionRemarks;
		}

		//Add amount details
		if (item.amount != undefined) {
       //'\u2212' is the unicode for minus sign
			var value = currency.symbolize(item.amount.currency + ' ' + Math.abs(item.amount.amount));
			item.displayValueSign = "";
			if (item.amountType != undefined && item.amountType.cmCode == "05")
      item.displayValueSign = "\u2212";
			item.displayValue = value;
		} else if (item.billingAmount != undefined) {
			if (item.transactionType != undefined && item.transactionType.cmCode == "04" && item.transactionType.codeType == "TTP") {
				item.displayValueSign = "";
				item.displayValue = currency.symbolize(item.billingAmount.currency + ' ' + Math.abs(item.billingAmount.amount));
			}
			else if (item.transactionType != undefined && item.transactionType.cmCode == "05" && item.transactionType.codeType == "TTP") {
        item.displayValueSign = "\u2212";
				item.displayValue = currency.symbolize(item.billingAmount.currency + ' ' + Math.abs(item.billingAmount.amount));
			}

		} //Add amount class details
		if (item.amountType != undefined && item.amountType.cmCode == "04") {
			item.displayValueClass = "text-brand-color";
		} else {
			item.displayValueClass = "";
		}

		//Add transaction tag details
		if (item.TransactionExtension != undefined) {
			if (item.TransactionExtension.transactionTag != undefined && Array.isArray(item.TransactionExtension.transactionTag)) {
				item.displayTransactionTag = item.TransactionExtension.transactionTag.toString();
			}
		} else if (item.transactionTag != undefined)
			item.displayTransactionTag = item.transactionTag;
		else
			item.displayTransactionTag = "";

		return item;
	},
	/* @event _savingsCardsChanged
	 * event when cards and savings change
	 */
	_savingsCardsChanged: function () {
		if (this.savings != undefined && this.cards != undefined && this.oprAccountList && this.oprAccountList.length !== 0) {
			this.userid = clientStorage.get(storageType.session, 'userId');
			var self = this;
			var transData = [];
			var accntArry = [self.savings, self.cards];
			if (this.oprAccountList && (accntArry[0].length > 0 || accntArry[1].length > 0)) {
				var ajaxCall = document.createElement('oe-ajax');
				ajaxCall.contentType = "application/json";
				ajaxCall.handleAs = "json";
				ajaxCall.url = "/api/" + "operativeaccounts" + "/" + this.oprAccountList[0].accountId + "/transactions?filter[order]=transactionDate%20DESC&filter[limit]=" + self.numberOfTransactions;
				ajaxCall.method = 'get';
				ajaxCall.addEventListener('response', function (event) {
					
					if (event.detail.response.length > 0) {
						_.forEach(event.detail.response, function (value) {
							transData.push(value);
						});
					}
					self._sortTransactions(transData);
					self.showRecentTransactionMsg = self.transactions.length === 0;
					self.recentTransactionLoader = false;
				});
				oeAjaxEventListner(ajaxCall);
				ajaxCall.addEventListener('error', function (event) {
					self.transactions = [];
					if (event.detail.error.message.indexOf('404') !== -1) {
						self.showRecentTransactionMsg = true;
					} else {
						self.showNodataFetchMsg = true;
					}
					self.recentTransactionLoader = false;
				});
				ajaxCall.generateRequest();
			} else {
				this.transactions = [];
				this.recentTransactionLoader = false;
			}
		}
	},
	/* @event getLocationDetails
	 * event to get location details
	 */
	getLocationDetails: function (lat, lng, index) {
		var self = this;
		if (typeof google != "undefined" && google && google.maps) {
			var latlng = new google.maps.LatLng(lat, lng);
			var geocoder = new google.maps.Geocoder();
			if (latlng != undefined && geocoder != undefined) {
				setTimeout(function () {
					geocoder.geocode({
						'latLng': latlng
					}, function (results, status) {
						if (status == google.maps.GeocoderStatus.OK) {
							if (results[1]) {
								var location = results[1].formatted_address;
								self.set('transactions.' + index + '.displayLocation', location);
							}
						}
					});
				}, 2000 * index);
			}
		}
	},
	downarrow: function (e) {
		var indx = e.model.index;
		if (e.keyCode === 40) {
			if (this.transactions.length - 1 === e.model.index) {
				this.shadowRoot.querySelector("#recentTransaction_0").focus();
			} else {
				indx += 1;
				this.shadowRoot.querySelector("#recentTransaction_" + indx).focus();
			}
		} else if (e.keyCode === 38) {
			indx -= 1;
			this.shadowRoot.querySelector("#recentTransaction_" + indx).focus();

		}
	},
	/* @event _formatTime
	 * event to format time
	 */
	_formatTime: function (date) {
		var hours = date.getHours();
		var minutes = date.getMinutes();
		var ampm = hours >= 12 ? 'PM' : 'AM';
		hours = hours % 12;
		hours = hours ? hours : 12;
		minutes = minutes < 10 ? '0' + minutes : minutes;
		var strTime = hours + ':' + minutes + ' ' + ampm;
		return strTime;
	},
	_formatDateTime: function (date) {
		var dateStr = [];
		dateStr.monthName = date.toLocaleString('default', {
			month: 'short'
		});
		dateStr.primaryDate = date.getDate();
		dateStr.year = window.OEUtils.DateUtils.format(date, "YY");
		return dateStr;
	},
	selectTransaction: function (e) {
		this._reset();
		let obj = {
			transID: " ",
			transDate: " ",
			valueDate: " ",
			transDateTime: " ",
			valueDateTime: " ",
			//natureOfTrans: " ",
			//transCategory: " ",
			//instrumentId: " "
		}
		obj.transID = e.model.item.transactionId;
		obj.transDate = this._formatDateTime(getNewDate(e.model.item.transactionDate));
		obj.transDateTime = this._formatTime(getNewDate(e.model.item.transactionDate));
		obj.valueDate = this._formatDateTime(getNewDate(e.model.item.valueDate));
		obj.valueDateTime = this._formatTime(getNewDate(e.model.item.valueDate));
		//obj.natureOfTrans = " ";
		//obj.transCategory = " ";
		//obj.instrumentId = " ";
		this.objTrans = obj;
		this.push('selTransaction', this.objTrans);

		this.$.recentTransDialog.$$("#recentTransDialog").open();
	},
	_reset() {
		this.selTransaction = [];
	},
	_toggleIronCollapse: function () {
		if (this.phone) {
			this.$.relevantTransactions.toggle();
			if (this.ironCollapseState) {
				this.$.ironCollapseIcon.classList.add('iron-collapse-open');
			} else {
				this.$.ironCollapseIcon.classList.remove('iron-collapse-open');
			}
		}
	},
});
